import { visibleNavItems } from "../data/navigation";

function MobileMenu({ auth, page, setPage }) {
  const items = visibleNavItems(auth);

  return (
    <nav className="mobile-menu" aria-label="Mobile app menu">
      {items.map((item) => (
        <button
          className={page === item.id ? "active" : ""}
          key={item.id}
          onClick={() => setPage(item.id)}
          type="button"
        >
          <span>{item.icon}</span>
          {item.label}
        </button>
      ))}
    </nav>
  );
}

export default MobileMenu;
